<template>
    <div>
        <b-navbar type="dark" variant="info">
            <b-navbar-brand href="#">Vis Audio</b-navbar-brand>

            <b-navbar-toggle target="nav-collapse" />

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item>
                        <router-link to="/">Player</router-link>
                    </b-nav-item>
                    <b-nav-item>
                        <router-link to="/about">About</router-link>
                    </b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav class="ml-auto">
                    <b-nav-item v-b-toggle.sidebar-1>
                        Configure
                    </b-nav-item>
                    <configure />
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
import Vue from 'vue';
import { NavbarPlugin } from 'bootstrap-vue';
import { Component } from 'vue-property-decorator';

import Configure from '@/components/configure';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(NavbarPlugin);

@Component({
    components: {
        Configure
    }
})
export default class Navbar extends Vue {}
</script>

<style scoped lang="less">
a {
    color: inherit;
    text-decoration: inherit;
}
</style>
